<div class="multiselect-container">
  <app-base-label
    *ngIf="!!label"
    [required]="checkRequiredField()"
    [label]="label"
    [labelOneLine]="labelOneLine"
    [ngClass]="'mb-1'"
  >
  </app-base-label>
  <div *ngIf="!isDisplayTagsOnly" class="p-inputgroup">
    <div class="p-inputgroup-addon">
      <i class="pi pi-search"></i>
    </div>
    <p-multiSelect
      #multiselect
      class="border-noround-left"
      [options]="options"
      [formControl]="fieldControl"
      [ngClass]="{ invalid: checkInvalidField() }"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      (onFilter)="filterChange.next($event.filter)"
      panelStyleClass="multiselect-panel-wrapper"
      placeholder="{{ placeholder | translate }}"
      [virtualScroll]="!!virtualScroll"
      [virtualScrollItemSize]="lazyLoading ? 200 : 38"
      [virtualScrollOptions]="{
        showLoader: true,
        loading: lazyLoading
      }"
      [lazy]="!!virtualScroll"
      (onLazyLoad)="onLazyLoad($event)"
    >
      <ng-template let-value pTemplate="selectedItems">
        <div *ngIf="fieldControl.value?.length > 0">
          {{ fieldControl.value?.length }} items selected
        </div>
        <div *ngIf="fieldControl.value?.length === 0 || !fieldControl.value">
          {{ placeholder | translate }}
        </div>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div>{{ option.label | translate }}</div>
      </ng-template>
    </p-multiSelect>
  </div>

  <div class="flex {{ isDisplayTagsOnly ? '' : 'mt-2' }} flex-wrap">
    <p-chip
      class="mr-2 mb-2"
      *ngFor="let item of fieldControl.value"
      [label]="getChipLabel(item) | translate"
      [removable]="!checkDisabled()"
      (onRemove)="handleRemove(item)"
    ></p-chip>
  </div>
  <app-base-label
    *ngIf="checkInvalidField()"
    [label]="errorMessage"
    mode="error"
  >
  </app-base-label>
</div>
